// extracted by mini-css-extract-plugin
export var bigText = "Figure-module--big-text--8c9dc";
export var figure = "Figure-module--figure--72fed";
export var figure__flow = "Figure-module--figure__flow--449c6 Figure-module--figure--72fed";
export var richText = "Figure-module--rich-text--0dc43";
export var text = "Figure-module--text--dc85a";